<template>
  <IconWrapper name="star" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.0193 9.49552L15.9193 8.90452C15.6873 8.87552 15.4853 8.73052 15.3783 8.51652L13.5503 4.85652C13.5473 4.85252 13.5453 4.84852 13.5433 4.84352C13.3753 4.53252 13.1143 4.27152 12.7993 4.10452C11.9523 3.67352 10.9013 4.00552 10.4543 4.85652L8.62434 8.51552C8.51634 8.72952 8.31234 8.87552 8.07134 8.90552L3.98034 9.49552C3.58434 9.55452 3.23734 9.73052 2.97934 10.0025C2.66134 10.3315 2.49134 10.7655 2.50034 11.2235C2.50934 11.6815 2.69634 12.1065 3.02434 12.4205L5.99134 15.2765C6.15634 15.4305 6.23334 15.6655 6.19334 15.8945L5.49234 19.9125C5.43234 20.2875 5.49634 20.6745 5.67034 20.9945C5.88834 21.4045 6.25134 21.7035 6.69334 21.8395C6.86034 21.8905 7.03134 21.9155 7.20034 21.9155C7.47834 21.9155 7.75334 21.8475 8.00234 21.7145L11.6623 19.8225C11.8743 19.7095 12.1293 19.7095 12.3463 19.8245L15.9883 21.7085C16.3153 21.8885 16.6883 21.9535 17.0813 21.8935C18.0203 21.7395 18.6633 20.8495 18.5103 19.9045L17.8103 15.8945C17.7693 15.6585 17.8453 15.4275 18.0183 15.2615L20.9763 12.4205C21.2533 12.1535 21.4353 11.7965 21.4853 11.4155C21.6083 10.4835 20.9493 9.62152 20.0193 9.49552Z"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
}>()
</script>
